import { render, staticRenderFns } from "./ProjectContentTreasureHunt.vue?vue&type=template&id=608ba3ab&scoped=true&"
import script from "./ProjectContentTreasureHunt.vue?vue&type=script&lang=js&"
export * from "./ProjectContentTreasureHunt.vue?vue&type=script&lang=js&"
import style0 from "./ProjectContentTreasureHunt.vue?vue&type=style&index=0&id=608ba3ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608ba3ab",
  null
  
)

export default component.exports